/** Integer santim strings from the API → "1,250.00 ETB" (BUILD_PLAN §5.15). Never via floats. */
export function formatMoney(santim: string | bigint, currency: string = 'ETB'): string {
  const v = typeof santim === 'bigint' ? santim : BigInt(santim);
  const neg = v < 0n;
  const abs = neg ? -v : v;
  const whole = (abs / 100n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  const frac = (abs % 100n).toString().padStart(2, '0');
  return `${neg ? '-' : ''}${whole}.${frac} ${currency}`;
}

/** "12.5" or "1,250" birr typed by a player → santim string. Null when invalid. */
export function parseBirr(input: string): string | null {
  const m = /^(\d{1,9})(?:\.(\d{1,2}))?$/.exec(input.trim().replace(/,/g, ''));
  if (!m) return null;
  return (BigInt(m[1]!) * 100n + BigInt((m[2] ?? '').padEnd(2, '0'))).toString();
}
